import {
  ChakraBox,
  CircularProgress,
  FAIconName,
  Icon,
} from '@equip.health/ui';
import { BaseMessage } from '@sendbird/chat/message';

interface PatientMyMessagePinProps {
  id: string;
  isMessagePinned: boolean;
  isPinLoading: boolean;
  chatMessage: BaseMessage;
  messageType: 'incoming' | 'outgoing';
  onTogglePin: (messageId: number) => void;
}

const PatientMyMessagePin = ({
  id,
  isMessagePinned,
  isPinLoading,
  chatMessage,
  messageType,
  onTogglePin,
}: PatientMyMessagePinProps) => {
  // maintain style with loading indcator until finished loading...
  const style = isMessagePinned ? 'pinned' : 'unpinned';

  if (isPinLoading) {
    return (
      <ChakraBox
        className={`sendbird-iconbutton ${style}-message sb-reaction-menu-${messageType}`}
        data-testid={`${id}__loading-${style}-message`}
        key={`${id}__loading-${style}-message`}
        mx={1}
        onClick={() => onTogglePin(chatMessage?.messageId)}
      >
        <CircularProgress
          data-testid={`circular-progress__${id}`}
          id={`circular-progress__${id}`}
          isIndeterminate
          size="20px"
        />
      </ChakraBox>
    );
  }

  return isMessagePinned ? (
    <ChakraBox
      className={`sendbird-iconbutton pinned-message sb-reaction-menu-${messageType}`}
      data-testid={`${id}__pinned-message`}
      key={`${id}__pinned-message`}
      mx={1}
      onClick={() => onTogglePin(chatMessage?.messageId)}
    >
      <Icon
        color="primary.50"
        key={`${chatMessage?.messageId !== chatMessage?.parentMessageId ? chatMessage?.messageId : chatMessage.parentMessageId}`}
        name={FAIconName.thumbTackSolid}
        size="lg"
      />
    </ChakraBox>
  ) : (
    <ChakraBox
      _hover={{
        backgroundColor: 'var(--chakra-colors-secondary-10)',
      }}
      className={`sendbird-iconbutton sendbird-parent-message-info__reaction-menu sb-reaction-menu-${messageType} sendbird-mouse-hover`}
      data-testid={`${id}__unpinned-message`}
      key={`${id}__unpinned-message`}
      onClick={() => onTogglePin(chatMessage?.messageId)}
    >
      <Icon color="black.100" name={FAIconName.thumbTackRegular} size="lg" />
    </ChakraBox>
  );
};

export default PatientMyMessagePin;
